// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Attachment-cls1___2d41100a3b4342bc67d{/*!*/}.Attachment-cls2__c0a3bde2e4c19bdb2478{background:#f3f4fa}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Attachment-cls1___2d41100a3b4342bc67d",
	"cls2": "Attachment-cls2__c0a3bde2e4c19bdb2478 Attachment-cls1___2d41100a3b4342bc67d"
};
export default ___CSS_LOADER_EXPORT___;
